import type { Polygon } from './types';

/**
 *
 * @description Convert wkt string to polygon.
 */
export function wktToPolygon(wkt: string): Polygon<number, number> | undefined {
  const polygonRegex =
    /^POLYGON\s*\(\(\s*((?:-?\d+(\.\d+)?\s+-?\d+(\.\d+)?\s*,\s*)*-?\d+(\.\d+)?\s+-?\d+(\.\d+)?\s*)\)\)$/;
  const match = wkt.match(polygonRegex);

  if (!match) {
    return undefined;
  }

  const coordinatesString = match[1];
  const coordinates = coordinatesString!.split(',').map((coord) => {
    const [x, y] = coord.trim().split(/\s+/).map(Number);
    return [x, y] as [number, number];
  });

  return { type: 'POLYGON', coordinates: coordinates };
}

/**
 *
 * @description Create an empty polygon.
 */
export function emptyPolygon(): Polygon<number, number> {
  return { type: 'POLYGON', coordinates: [] };
}
